import { Tooltip, TooltipProps } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';

const INFO_ICON = 'data_prep_info.svg';
const ICON_PATH = imgPath(INFO_ICON);
const tooltipProps: TooltipProps = {
    getContent: () => <span>{Messages.encryptionTooltip()}</span>
};

export const EncryptionTooltip = (): JSX.Element => {
    /* eslint-disable jsx-a11y/alt-text */
    return (
    <Tooltip {...tooltipProps}>
      <img style={{ minHeight: 15, position: 'relative', top: 3, left: 7}} src={ICON_PATH} />
    </Tooltip>
  );
};
